export default "__VITE_ASSET__DTB0pmzD__"